import request from './httpService';

/**
 * PreferencesService
 * Thin wrapper around httpService for tenant and location preferences.
 * Uses existing endpoints (tenant defaults and location overrides).
 */
const getBusinessPreferences = async (options = {}) => {
    return request({
        method: 'GET',
        url: '/preferences/tenant/defaults',
        suppressErrorToast: options.suppressErrorToast === true
    });
};

const getLocationPreferences = async (locationId, options = {}) => {
    return request({
        method: 'GET',
        url: `/preferences/tenant/location/${locationId}`,
        suppressErrorToast: options.suppressErrorToast === true
    });
};

const saveLocationPreferences = async (locationId, preferences) => {
    return request({
        method: 'POST',
        url: `/preferences/tenant/location/${locationId}`,
        data: preferences
    });
};

const updateBusinessPreferences = async (preferences) => {
    return request({
        method: 'PUT',
        url: '/preferences/tenant/defaults',
        data: preferences
    });
};

const deleteLocationPreferences = async (locationId) => {
    return request({
        method: 'DELETE',
        url: `/preferences/tenant/location/${locationId}`
    });
};

const getFormattedPreferences = async (locationId = null) => {
    const endpoint = locationId
        ? `/preferences/tenant/location/${locationId}/formatted`
        : `/preferences/tenant/formatted`;
    return request({ method: 'GET', url: endpoint });
};

const validatePreferences = async (preferences) => {
    return request({
        method: 'POST',
        url: '/preferences/validate',
        data: { preferences }
    });
};

export const PreferencesService = {
    getBusinessPreferences,
    getLocationPreferences,
    saveLocationPreferences,
    updateBusinessPreferences,
    deleteLocationPreferences,
    getFormattedPreferences,
    validatePreferences
};
